var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserAlt5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.58746 7.98515C8.89439 7.15346 8.0165 6.57591 7.0462 6.27558C8.0165 5.76733 8.66336 4.75082 8.66336 3.57261C8.66336 1.88614 7.30033 0.5 5.59075 0.5C3.88118 0.5 2.54125 1.90924 2.54125 3.59571C2.54125 4.75082 3.18811 5.76733 4.15841 6.29868C3.18811 6.59901 2.33333 7.17657 1.61716 8.00825C0.600655 9.20957 0.0231023 10.8729 0 12.698C0 12.9059 0.115512 13.0908 0.277228 13.1601C0.900986 13.4835 3.16501 14.5 5.59075 14.5C8.22442 14.5 10.3267 13.4604 10.9274 13.137C11.0891 13.0446 11.2046 12.8597 11.2046 12.6749C11.1815 10.8729 10.604 9.20957 9.58746 7.98515ZM5.61386 1.58581C6.72277 1.58581 7.64686 2.4868 7.64686 3.61881C7.64686 4.75082 6.74587 5.65181 5.61386 5.65181C4.48184 5.65181 3.58085 4.75082 3.58085 3.61881C3.58085 2.4868 4.50495 1.58581 5.61386 1.58581ZM5.61386 13.4835C3.69637 13.4835 1.82508 12.7442 1.0627 12.3746C1.15511 10.9191 1.61716 9.62541 2.42574 8.65511C3.25742 7.66172 4.38943 7.10726 5.61386 7.10726C6.83828 7.10726 7.97029 7.66172 8.80198 8.65511C9.61056 9.60231 10.0957 10.9191 10.165 12.3746C9.44884 12.7442 7.69307 13.4835 5.61386 13.4835Z",
    fill: "#444444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserAlt5);
export default __webpack_public_path__ + "static/media/user-alt-5.42ece9614ebbc98951371e5fee55080d.svg";
export { ForwardRef as ReactComponent };